import React, { type ReactNode } from 'react';
import { PAD, Reveal, SlideFrame, SlideHeader, t } from './primitives';
import { DERMX_SCREENS, LEO_ASSETS, LEO_GREEN_LIGHT, MiniBarChart, PhoneFrame } from './visuals';
type WorkCardProps = {
  brand: string;
  title: string;
  meta: string;
  visual: ReactNode;
};
function WorkCard({
  brand,
  title,
  meta,
  visual
}: WorkCardProps) {
  return <article className="flex min-h-0 w-full flex-col rounded-[0.9vw] border border-white/10 bg-white/[0.035] p-[1.1vw]" data-id="element-241" data-mp="34sd2iq4j7b4o">
      <div className="min-h-0 flex-1 overflow-hidden" data-id="element-242" data-mp="39jms5qq2yegk">{visual}</div>
      <div className="mt-[1.6vh] shrink-0" data-id="element-243" data-mp="39kxvxqjizm7o">
        <p className={`${t.label} font-semibold uppercase tracking-[0.18em] text-[#A26BFF]`} data-id="element-244" data-mp="2vsq0c23za1ak">
          {brand}
        </p>
        <h3 className={`${t.small} mt-[0.8vh] font-semibold leading-[1.2] text-white`} data-id="element-245" data-mp="2zr7akuip3rw7">
          {title}
        </h3>
        <p className={`${t.label} mt-[0.7vh] leading-[1.35] text-white/50`} data-id="element-246" data-mp="2qslst1l1sgwh">{meta}</p>
      </div>
    </article>;
}
export function ProvenWork() {
  return <SlideFrame data-id="element-247" data-mp="2kf00h2tt5kfp">
      <div className={`flex h-full w-full flex-col ${PAD}`} data-id="element-248" data-mp="2kinue33608uy">
        <SlideHeader eyebrow="03 — Proof" title="Already delivering campaign work" accent="with LEO Pharma" kicker="Snakker for LEO Pharma" data-id="element-249" data-mp="2fgezv2an8yqq" />

        <div className="mt-[3.2vh] grid min-h-0 flex-1 grid-cols-4 gap-[1.1vw]" data-id="element-250" data-mp="2ohwjuvr69kkp">
          <Reveal delay={0.2} className="flex min-h-0" data-id="element-251" data-mp="20s2awp9z4g5q">
            <WorkCard brand="ANZUPGO®" title="Patient Application Guide" meta="Interactive guide · ES / EN · mobile + desktop · video, FAQ and reminders" visual={<div className="flex h-full items-center justify-center" data-id="element-253" data-mp="25rn9uzp58oig">
                  <PhoneFrame className="h-full aspect-[9/17]" data-id="element-254" data-mp="25qc44uc516op">
                    <img src={LEO_ASSETS.anzupgoStart} alt="ANZUPGO® patient application guide start screen" className="h-full w-full object-cover" data-id="element-255" data-mp="1i113rdyp9eb3" />
                  </PhoneFrame>
                </div>} data-id="element-252" data-mp="20stz3f18rblz" />
          </Reveal>

          <Reveal delay={0.3} className="flex min-h-0" data-id="element-256" data-mp="3i2hbodxmffi8">
            <WorkCard brand="Leo Pharma UK" title="DermaWorld campaign updates" meta="Portfolio recommendation, wave 1 & 2 packages, measurement plan" visual={<img src={LEO_ASSETS.anzupgoTubes} alt="ANZUPGO® product campaign imagery from the LEO UK updates deck" className="h-full w-full rounded-[0.5vw] object-cover" data-id="element-258" data-mp="2u7oerz3f9ta3" />} data-id="element-257" data-mp="3musf3qrkljfj" />
          </Reveal>

          <Reveal delay={0.4} className="flex min-h-0" data-id="element-259" data-mp="386xku5xwz70c">
            <WorkCard brand="DERMX" title="Webinar series — Leo Pharma UK" meta="Website-embedded Snak + campaign series across the HCP adoption ladder" visual={<img src={DERMX_SCREENS.offerings} alt="DERMX webinar series proposal — two connected offerings" className="h-full w-full rounded-[0.5vw] border border-white/12 object-cover object-top" data-id="element-261" data-mp="27y7m5nx347ja" />} data-id="element-260" data-mp="jebsggmj2fak" />
          </Reveal>

          <Reveal delay={0.5} className="flex min-h-0" data-id="element-262" data-mp="1u5rqj86ijbse">
            <WorkCard brand="Tralokinumab" title="Real-world effectiveness study" meta="19 studies, 911 patients · EASI 75 response at weeks 4–32" visual={<div className="h-full rounded-[0.5vw] border border-white/10 bg-white/[0.04] p-[0.9vw]" data-id="element-264" data-mp="1g69y8iu0dgea">
                  <MiniBarChart title="EASI 75 response" accent={LEO_GREEN_LIGHT} bars={[{
              label: 'W4',
              value: 28
            }, {
              label: 'W16',
              value: 59
            }, {
              label: 'W24',
              value: 61
            }, {
              label: 'W32',
              value: 84
            }]} data-id="element-265" data-mp="1b8gsts0j4qf2" />
                </div>} data-id="element-263" data-mp="1p7gdkokx8l5y" />
          </Reveal>
        </div>

        <Reveal delay={0.6} className="mt-[2.8vh] flex shrink-0 items-baseline gap-[2vw] border-t border-white/10 pt-[2.4vh]" data-id="element-266" data-mp="1tae64me7mwyl">
          <span className={`${t.label} shrink-0 font-semibold uppercase tracking-[0.22em] text-[#A26BFF]`} data-id="element-267" data-mp="1y7nurztrz4ld">
            The point
          </span>
          <p className={`${t.small} leading-[1.35] text-white/75`} data-id="element-268" data-mp="1obb317hsj0t9">
            The model is already running inside LEO — brand campaigns, patient support,
            HCP series, and real-world evidence, produced as reusable Snaks.
          </p>
        </Reveal>
      </div>
    </SlideFrame>;
}